export const iconFontAwesomeConstructionTrowelBricks = (
	<i className="fa-solid fa-trowel-bricks"></i>
);
